import { api } from '../../apiAxios';
import { urlHttpGov } from '../../urls';
import { getToken } from '../../LStorage/token';

class NoticiasService {
    private baseURL: string = `${urlHttpGov}${process.env.REACT_APP_BACKEND === 'local' ? '' :'/gestor'}/news`;
    private baseURLEntity: string = `${urlHttpGov}${process.env.REACT_APP_BACKEND === 'local' ? '' :'/gestor'}/entity`;

    async getGestorNoticias(id: string | number, signal: AbortSignal): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/entity/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async postGestorNoticias(
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.post(`${this.baseURL}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async putGestorNoticias(
        id: string | number,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}/${id}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async patchGestorNoticias(
        id: string | number,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.patch(`${this.baseURLEntity}/noticia/${id}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async deleteGestorNoticias(
        id: string | number,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.delete(`${this.baseURL}/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async deleteGestorNoticiasImage(
        id: string | number,
        file: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.delete(`${this.baseURL}/${id}/image`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                data: {
                    image: file,
                },
                signal
            });

        return data;
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new NoticiasService();
